import {FC, useEffect, useRef, useState} from 'react'
import './payment.css'
import {Spinner} from '_core/components/Loader/Loader'
import { IConfig } from 'payengine/dist/utils/IConfig';
import { loadPayengine } from 'payengine';
import { ErrorMessage } from '../Stripe/StripeCard';

const css = {
  border: 'none',
  lineHeight: 'normal',
  padding: '0',
  'font-size': '14px',
  with: '100%',
  'font-family': 'Inter, sans-serif !important;',
}

type Props = {
  config: any
  onPayEngineLoaded: (form: any) => void
  errors: any
}
const CardForm: FC<Props> = ({onPayEngineLoaded, config, errors}) => {
  const payEngineRef = useRef(false)
  const [isLoading, setIsLoading] = useState(true)
  const paymentConfig: IConfig = {
    publicKey: config.publicKey,
    scriptURL: config.payengineScriptURL,
  }

  useEffect(() => {
    if (!payEngineRef.current && paymentConfig) {
      payEngineRef.current = true
      loadPayengine(paymentConfig).then((pe: any) => {
        createSecureFields(pe)
      })
    }
  }, [paymentConfig])

  function createSecureFields(pe: any) {
    pe.SecureFields.create().then((form: any) => {
      form.field('#cardNumber', {
        type: 'card-number',
        name: 'card_number',
        errorColor: '#f1416c',
        placeholder: 'Card Number',
        showCardIcon: false,
        validations: ['required', 'validCardNumber'],
        css,
      })

      form.field('#cardCvv', {
        type: 'card-security-code',
        name: 'card_cvc',
        errorColor: '#f1416c',
        placeholder: 'CVC',
        maxLength: 4,
        validations: ['required', 'validCardSecurityCode'],
        css,
      })

      form.field('#cardExpiry', {
        type: 'card-expiration-date',
        name: 'card_exp',
        errorColor: '#f1416c',
        placeholder: 'MM / YY',
        validations: ['required', 'validCardExpirationDate'],
        css,
      })

      onPayEngineLoaded(form)
      setIsLoading(false)
    })
  }

  return (
    <div>
      {isLoading && <Spinner />}
      <div id='payengine-card'>
        <div className='row mb-10'>
          <div className='col'>
            <div id='cardNumber' className='form-control form-control-lg' />
            <ErrorMessage error={errors.card_number} />
          </div>
        </div>
        <div className='row mb-10'>
          <div className='col'>
            <div id='cardExpiry' className='form-control form-control-lg ' />
            <ErrorMessage error={errors.card_exp} />
          </div>
          <div className='col'>
            <div id='cardCvv' className='form-control form-control-lg' />
            <ErrorMessage error={errors.card_cvc} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CardForm
